import 'bootstrap'
import moment from 'moment'
import './jquery'
import DataTable from 'datatables.net-dt';
import intlTelInput from 'intl-tel-input';
import './ext/jquery-ui-1.12.1.min'
import underscore from 'underscore'
import { TourlaneFlex } from './twilio-common'
import { TourlaneSuite, TourlaneIframeCommunication } from './common'
import { ReloadToFindLead, NewLeadNotification, displayCallNotification } from './notifications'
import './ext/utils'
import './ext/fontawesome-5'
import './ext/bootstrap-datetimepicker.min'
import './ext/daterangepicker.3.0.5.min'
// import '../public/js/jquery.dataTables-1.10.19.min'
import './auto_dialer'
import './auto_dialer_test'
import './kpis-modal'
import './unlock-lead'

window._ = underscore
window.TourlaneFlex = TourlaneFlex
window.TourlaneSuite = TourlaneSuite
window.TourlaneIframeCommunication = TourlaneIframeCommunication
window.intlTelInput = intlTelInput
window.moment = moment
window.ReloadToFindLead = ReloadToFindLead
window.NewLeadNotification = NewLeadNotification
window.displayCallNotification = displayCallNotification
DataTable(window, $)

// Add CSRF token to All Ajax requests
$(document).on('ajaxSend', function(_event, jqxhr, _settings) {
  const token = $('meta[name="csrf-token"]').attr('content')
  jqxhr.setRequestHeader('X-CSRF-Token', token);
});

window.scrollToBottom = function scrollToBottom() {
  window.scroll({
    top: document.body.scrollHeight,
    left: 0,
    behavior: 'smooth'
  });
}

